import { Link } from 'react-router'
import { ServiceCard } from '@/components/sv'
import { useCompanyPath } from '@/lib/hooks'
import { DockerLogo, GitHubLogo } from '@/logos'

type Props = {
  templateInstance: any
  service: any
}

export const TemplateAppCard = ({ templateInstance, service }: Props) => {
  const { getCompanyPath } = useCompanyPath()
  const instanceService = templateInstance?.services.find(
    (s: any) => s.serviceName === service.name
  )
  const appName = instanceService?.name ?? ''
  const infoText =
    instanceService?.status === 'created'
      ? 'Waiting for deployment'
      : instanceService?.status === 'waitForConnection'
        ? 'Waiting for connection'
        : instanceService?.status === 'deploying'
          ? 'Deploy initiated'
          : null
  const info = (
    <div className="flex items-center gap-1">
      {instanceService?.status ? (
        <>
          <span>{infoText}</span>
          <span> — </span>
        </>
      ) : null}
      {service.serviceType === 'applicationDockerImage' ? (
        <DockerLogo className="fill-current size-3.5 flex-shrink-0 ml-1" />
      ) : (
        <GitHubLogo className="[&>path]:fill-current size-3.5 flex-shrink-0 ml-1" />
      )}
      <span className="truncate max-w-[250px]">{service.source}</span>
    </div>
  )

  const AppCard = () => (
    <ServiceCard
      key={service.id}
      type="app"
      disabled={!instanceService?.status}
      status={
        !instanceService?.status
          ? 'deploymentCancelled'
          : instanceService?.status === 'created'
            ? 'creating'
            : instanceService?.status === 'waitForConnection'
              ? 'deploymentInProgress'
              : instanceService?.status === 'deploying'
                ? 'deploymentSuccess'
                : 'deploymentFailed'
      }
      name={service.displayName}
      info={info}
    />
  )

  if (instanceService?.status) {
    return (
      <Link
        to={getCompanyPath({
          pathname: '/app/:appName/overview',
          variables: { appName },
        })}
      >
        <AppCard />
      </Link>
    )
  } else {
    return <AppCard />
  }
}
